export default {
  'home': '首頁',
  course: '課程',
  live: '直播',
  short_video: "短視頻",
  public_exam: '公開考試',
  training_class: '面授班',
  infor_list: '資訊',
  Knowledge_lib: '文庫',
  intelligent_circle: '知圈',
  learning_footprint: '學習足跡',
  my_course: '我的課程',
  my_exam: '我的考試',
  learn_map: '學習地圖',
  zhi_niao: '知鳥',
  exam: '考試',
  EBOOK: '電子書',
  i_want_public: '我要發帖',
  questionnaire: '問卷',
  new_questionnaire: "新問卷",
  my_training_class: '我的面授班',
  my_questionnaire: '我的問卷',
  practice_train: '實踐培訓',
  my_homework: '我的作業',
  training_project: '培訓項目',
  learn_tasks: '學習任務',
  more: '查看更多',
  error: '請求出錯',
  fail: '請求失敗',
  confirm: '確定',
  confirm_empty: '確 定',
  cancel: '取消',
  check: '查看',
  practice: '實操',
  stage_learn_project: "階段學習項目",
  nonsupport: '知鳥網頁版暫不支持查看該資源，敬請期待！',
  no_support_vs: '暫不支持查看該資源，敬請期待！',
  intelligent_portal: '智門戶暫不支持進入我的面授班，請使用知鳥App',
  playback: '回放',
  back: '返回',
  commend: '推薦',
  exam_score: '考試成績',
  ten_thousand: '萬',
  learned: '已學',
  no_learned: '未學',
  has_learned: '已學習',
  is_passed: "已通過",
  fail_passed: '不通過',
  not_passed: '未通過',
  to_be_approved: '待通過',
  score: '分',
  no_score: '暫無評分',
  Intelligent_accompaniment: "智能陪練",
  conmment_score: '評分：',
  submit__score: "提交評分",
  all: '全部',
  i_got_it: "我知道了",
  book_tip: '該課件類型為電子書，目前暫時只支持在知鳥APP上學習。請通過知鳥APP學習該課件。',
  no_permission: '抱歉，您沒有查看此課程的權限',
  go_training_programs: '該資源屬於培訓項目內容，為了學習數據的有效性，請前往對應的培訓項目學習！',
  need_accept_oversight: '抱歉！學習該課程需要接收監管，只在app上進行學習。',
  go_app_learn: '為保證學習數據有效性，請使用知鳥APP學習。',
  video_learn: '該課程需要視頻監學，必須通過知鳥APP進行學習。請打開知鳥APP學習該課程。',
  need_sign: '該課程需要簽名，必須通過知鳥APP進行學習簽名。請打開知鳥APP學習該課程。',
  lift_lockdown: '已達到截屏最大次數，禁止再次進入課程，請聯系管理員解封',
  punch_in_completed: '完成打卡驗證',
  please_punch_in_completed: '請完成打卡驗證',
  verify_complete: '驗證完成',
  Initializing: '初始化中...',
  intelligent_detection: '智能檢測中...',
  click_complete_verification: '點擊完成驗證',
  second: '秒',
  enter_verification_code: "請輸入驗證碼",
  captcha_error: '驗證碼錯誤',
  verification_code: '驗證碼',
  submit_success: '提交成功',
  author: '作者',
  producer: '製作人',
  brief_introduction: '簡介：',
  pack_up_detail: '收起詳細介紹',
  spread_details: '展開詳細介紹',
  all_comments: '全部評論',
  headline_Review: '頭條評論',
  latest_comments: '最新評論',
  no_comments: '還沒有人發表評論',
  publish_Comment: "發表評論",
  no_more_comments: "沒有更多評論了",
  see_more_comments: "查看更多評論",
  submit_comment_tip: '寫夠5個字才能提交哦，麽麽噠',
  disabled_drag: '本課程設置為禁止拖動',
  tip_screen: '请始终保持课程窗口最大化，否则无法开始学习',
  goto_complete: '請先完成課程的學習',
  network_anomaly: '網絡異常',
  abnormal: '異常',
  no_data: '暫無數據',
  login_password: "請輸入登錄密碼",
  enter_password: '請輸入密碼',
  enter_password_again: '密碼錯誤，請重新輸入',
  enter_password_info: "請輸入登錄密碼以校驗身份",
  next_txt: '下一步',
  not_started: '未開始',
  ongoing: '進行中',
  Living: '直播中',
  is_over: '已結束',
  playing_back: '回放中',
  invalid_live: '無效直播',
  living: '正在直播',
  finished: '已完成',
  no_finished: '未完成',
  returned: '被退回',
  training_time: '培訓時間',
  format_time_year: 'YYYY年MM月DD日',
  format_time_mouth: 'MM月DD日',
  this_time_score: "本次成績得分",
  affirm_submit: '是否確認提交',
  upload_file: '上傳文件',
  files: '文件',
  title_name: "名稱",
  typeof: '類型',
  support: "贊",
  like_num: '點贊數',
  clock_support: "點贊",
  select_more: '查看全部',
  unread: '未讀',
  my_news: '我的消息',
  my_setting: '我的設置',
  user_center: "個人中心",
  my_circle: '我的知圈',
  no_nickName: '暫無昵稱',
  no_content: "還沒有內容",
  delete: '刪除',
  go_face_class: '立即前往該面授班嗎？',
  go_exam: '立即前往該考試開始答題嗎？',
  go_live: '立即前往該直播嗎？',
  go_learn_map: '立即前往該學習地圖嗎？',
  go_intelligent_circle: '立即前往該帖子嗎？',
  web_cannot_open: "網頁無法打開此類消息",
  use_zhiniao_app: '請使用知鳥app閱讀此消息',
  intelligent_portal_home: '01Web-智門戶首頁',
  opening_time: '開課時間',
  day: '天',
  hours: '時',
  minutes: '分',
  seconds: '秒',
  no_limits: '不限',
  live_time: '直播時間',
  cut_off_time: '截止時間：',
  training_matters: "培訓事項",
  face_class_Introduction: '面授班介紹',
  schedule: '日程表',
  honor_rank: '榮譽榜',
  discuss: '討論區',
  homeWork: '作業',
  certificate_completion: '結業證書',
  head_master: '班主任',
  head_master_colon: '班主任： ',
  training_matters1309: '1309Web-查看培訓事項',
  check_training_Intro1310: '1310Web-查看培訓介紹',
  check_schedule1304: '1304Web-查看日程表',
  check_rank1306: '1306Web-查看榮譽榜',
  go_discuss1307: '1307Web-進入討論區',
  show_training_detail1301: '1301Web-顯示培訓班詳情',
  trainclass13: '13Web-培訓班',
  web_learn_task04: '04Web-學習任務',
  logout: "退出登錄",
  circle: '圈子',
  search_circle: '搜索圈子',
  all_circle: '全部圈子',
  concel_empty: "取 消",
  confirm_txt: "確 定",
  copy_success: '復製成功',
  copy_failed: "復製失敗",
  insert_picture: '插入圖片',
  input_text: '請輸入正文內容',
  search_name_number: "搜索姓名/員工編號",
  not_found_search: "未找到搜索項",
  enclosure_title: '附件名稱',
  url: '鏈接',
  operation: '操作',
  posted: '發帖',
  my_post: '我的發帖',
  undercarriage: '下架',
  setting_success: '設置成功',
  setting_failed: '設置失敗',
  undercarriage_success: "下架成功",
  undercarriage_failed: "下架失敗",
  one_minutes_ago: '1分鐘前',
  much_minutes_ago: '{time}分鐘前',
  much_hours_ago: '{hourGap}小時前',
  min_length_limit: '寫夠{minLength}字才能提交哦',
  cancel_topping: '取消置頂',
  set_topping: '設為置頂',
  cancel_essence: '取消精華',
  set_essence: '設為精華',
  practical_training: "實踐培訓",
  filled_in: "已填寫",
  no_filled_in: "待填寫",
  not_open: "未開放",
  summary_newcomers: "新人每周總結",
  training_time_colon: "培訓時間:",
  unopened: '未開啟',
  daily_summary_newcomers: "新人每日總結",
  mentor_name: '指導人名稱:',
  interview_track_record: '面談跟蹤記錄表',
  evaluated: '已評價',
  to_be_evaluated: '待評價',
  reviewed: '已審閱',
  to_be_reviewed: '待審閱',
  formal_exam: '正式考試',
  mock_exam: '模擬考試',
  test_num: '共{testNum}題',
  total_score: '滿分',
  not_yet: '還沒有',
  anchor: '主播：',
  total_pics: "共{smallImgList}張圖片",
  collection: '收藏',
  cover_map: '封面圖',
  enterprise_course: '企業課',
  no_resources_found: '沒有搜索到資源',
  learn_map11: '11Web-學習地圖',
  my_learn_map: "我的學習地圖",
  not_learning: "未學習",
  other: '其它',
  posts_count: '帖子數：',
  follow_count: '關註數：',
  followed: '已關註',
  follow: '關註',
  concel_follow: '已取消關註',
  follow_success: '關註成功',
  confirm_concel_follow: '確定取消關註嗎？',
  Background_process_error: '後臺處理錯誤',
  anchor_top_list: "圈主排行榜",
  rank: '排行榜',
  Recent_classes: '最近開班',
  most_popular: '最熱門',
  registration_time: '報名時間',
  reported_limit: '已報限報',
  no_training_class: '還沒有面授班',
  validation_failed: '驗證失敗',
  course_list07: "07Web-課程詳情頁",
  limit_value_tip: '感謝您認真學習，您學習已超過{limitValue}小時，為保障學習質量，請您休息，明天再學習吧！',
  scored: '已評分',
  mark_score: '我要評分',
  learn_order: '該培訓項目需要嚴格按照順序學習',
  go_continue: '請繼續學習以下資源',
  click_catalog0703: '0703Web-點擊目錄項',
  give_mark0706: '0706Web-參與評分',
  show_course_datail0701: "0701Web-顯示課程詳情頁",
  current_project_completed: '當前項目已結訓',
  about_to_quit: '已到達培訓項目結束時間，即將退出學習',
  countdown: '確定（{countNum}s）',
  get_exam_fail: '網絡異常，獲取考試資源失敗',
  not_allow_quit: '考試中途不允許退出',
  exam_detail: '考試詳情',
  select_location: '請先選擇地理位置',
  custom_address: '自定義地址',
  add_location: "添加地理位置",
  effective_range: "有效範圍",
  metre: '米',
  search: '搜索',
  system_error: '系統錯誤，請稍後再試',
  Live_not_started: '直播未開始，請稍後再試',
  spread: '展開',
  pack_up: '收起',
  Login_recovery: '登錄態恢復',
  browser_version_low: '抱歉，您的瀏覽器版本過低可能影響知鳥網頁版部分功能的使用。請升級到IE{version}及以上的瀏覽器或使用chrome瀏覽器打開知鳥網頁版。',
  click_pic0104: '0104Web-點擊頭像',
  check_wallet0102: "0102Web-查看錢包",
  my_setting0106: '0106Web-我的設置',
  quit_login0107: '0107Web-退出登錄',
  my_reimbursement: '我的報銷',
  my_class_audit: '我的開班審核',
  wallet: '錢包',
  check_mes0103: '0103Web-查看消息',
  news: '消息',
  enter_search_keywords: '請輸入搜索關鍵字/直播ID/短視頻ID',
  loading: '加載中...',
  not_support_upload: '文件中有不支持上傳的類型，請重新選擇',
  upload_attachment: "上傳附件",
  please_enter: "請輸入",
  multiple_choice_qus: '多選題',
  single_choice_qus: '單選題',
  judgment_qus: '判斷題',
  subjective_qus: '主觀題',
  photographs: '圖片題',
  completion: '填空題',
  matching: '連線題',
  attachment: '附件題',
  customs_clearance_task: '通關任務',
  sparring_robot: '陪練機器人',
  learn: "學習",
  share: "分享",
  make_comments: '對{typeName}「{name}」進行了評分',
  collect: "收藏",
  watch: "觀看",
  host: "主持",
  send_gift: "贈禮了",
  completion_graduation: "完成結業",
  breakthrough_complete: '闖關完成',
  participate_in: '參與',
  read: '閱讀',
  achieve_score: '，成績{score}分',
  take_part_in: '參加',
  no_corporate_identity: '抱歉，你沒有企業身份，無法使用知鳥網頁版',
  no_homepage: '抱歉，你沒有可見的首頁，無法使用知鳥網頁版',
  reset_password: '重設密碼',
  access_time: '獲得時間：',
  my_certificate: '我的證書',
  no_certificate: '還沒有證書哦',
  custom_theme: '自定義專題',
  course_topics: '課程專題',
  no_permission_learn: '你沒有權限學習該資源',
  points_acquisition_details: '積分獲取明細',
  date: 'YYYY年MM月',
  total_points: '總積分',
  points_rules: '積分規則',
  check_exam: '0404Web-查看考試',
  examination_time: '考試時間：',
  min_score: '及格分{minScore}分',
  total_score_detail: '滿分{totalScore}分',
  question_num: '題目數{questionNum}題',
  learnTime_num: '觀看/收聽時長至少{learnTime}分鐘已學',
  learnTime_zero: '點擊即算已學',
  show_exam_list: '0403Web-顯示我的考試列表',
  resource_center: '資源中心',
  edit: '編輯',
  edit_avatar: '編輯頭像',
  avatar: '頭像',
  upload_files_failed: '上傳失敗',
  upload_files_success: '上傳成功',
  upload_again: '重新上傳',
  preview_head_image: '頭像預覽',
  current_identity: '當前身份',
  switch: '切換',
  learn_time: '學習時長',
  learn_num: '學習次數',
  learn_course: '已學課程',
  files_size_limit_tip: '圖片需要小於2M,請控製圖片大小',
  support_type_img: '圖片只支持JPG和PNG格式，請確保上傳圖片格式正確。',
  certificate: '證書',
  passwoed_not_empty: '舊密碼、密碼和確認密碼不能為空！',
  old_password: "舊密碼",
  enter_old_password: "請輸入舊密碼",
  pwd_format_error: "密碼格式錯誤",
  new_password: "新密碼",
  enter_pwd_rules: "請輸入至少8位，並且包含英文和數字",
  confirm_pwd_error: "密碼不一致",
  confirm_pwd: "確認密碼",
  enter_pwd_again: "請再次輸入密碼",
  reset_pwd_success: "恭喜，重設密碼成功！",
  go_back_home: "返回首頁",
  sevice_error: '服務器錯誤！',
  client_error: '客戶端錯誤！',
  login_again_please: '為了您的賬戶安全，請重新登錄',
  account_out_time: '您的賬號已超時，請重新登錄。',
  zhiniao_portal: '知鳥平臺',
  zhiniao_web_page: '知鳥網頁版',
  quit: '退出',
  download: '下載',
  imprint: '打印',
  submit: '提交',
  nothing: '無',
  comment_click: '評論',
  updated_btn: '刷新',
  not_yet_course: '還沒有課程',
  post_count: '{postCount}個帖子',
  give_score: "評分",
  no_data_yet: '暫無內容',
  which_level: '第{num}關',
  person_num: "{num}人",
  emojiImg: '表情',
  step_learn: '階段學習項目',
  living_replay: '直播回放',
  phone_num: '手機號需為11位數字',
  pwd_length: '密碼長度不得超過16位',
  learn_typeName: '學習{typeName}「{name}」',
  share_typeName: '分享{typeName}「{name}」',
  commend_typeName: '對{typeName}「{name}」進行了評分',
  collect_typeName: '收藏{typeName}「{name}」',
  look_typeName: '觀看{typeName}「{name}」',
  host_typeName: '主持{typeName}「{name}」',
  gift_typeName: '贈禮了{typeName}「{name}」',
  completed_typeName: '{typeName}「{name}」完成結業',
  chuangguan_typeName: '闖關完成{typeName}「{name}」',
  participate_typeName: '參與{typeName}「{name}」{score}',
  grades_score: '，成績{score}分',
  read_typeName: '閱讀{typeName}「{name}」',
  comment_typeName: '評論{typeName}「{name}」',
  participate_in_training: '參訓{typeName}「{name}」{score}',
  result_durationStr:'{result}，時長{durationStr}',
  typeValue_trainClassName:'參加{typeValue}「{trainClassName}」',
  totalScoreStr:'{totalScoreStr}分',
  pic_i_extend:'圖片{i}.{extend}',
  latest_release:'最新發布',
  registered:'已報名',
  quantity: '{quantity}個',

  face_to_face_teaching:'面授課',
  quantity: '{quantity}個',
  voice_playing:'語音直播中',
  voice_back_playing:'語音直播回放中',
  no_reviewed:'未審閱',
  myOrder:'我的訂單',
  and_too:'以及',
  cloud_school_project:'雲校培訓項目詳情頁',
  cloud_school_project_list:'雲校培訓項目公開列表',
  case_study_questions:'案例分析題',
  acknowledge:'確認',
  submitted:'已提交',
  invoicing_info_submitted:'已提交開票信息',
  invoice_applied:'已申請開票',
  Invoiced:'已開票',
  audit_failed:'審核未通過',
  revoked:'已撤銷',
  cancel_invoice_request:'確認撤銷該發票申請嗎？',
  submit_invoice_request:'確認提交該發票申請嗎？',
  submit_application:'提交申請',
  modify_application:'修改申請',
  application_canceled:'撤銷申請',
  lump_sum_colon:'總金額：',
  enter_email_address:'請輸入郵箱地址',
  email_address_colon:'郵箱地址：',
  enter_mailing_address:'請輸入郵寄地址',
  mailing_address_colon:'郵寄地址：',
  enter_connect_num:'請輸入聯系電話',
  connect_num_colon:'聯系電話：',
  electronic_Invoice:'電子發票',
  paper_Invoice:'紙質發票',
  billing_method:'開票方式：',
  enter_bank_account:'請輸入銀行帳號',
  bank_account_num:'銀行帳號：',
  enter_opening_bank:'請輸入開戶銀行',
  opening_bank:'開戶銀行：',
  enter_registered_number:'請輸入註冊電話',
  registered_number:'註冊電話：',
  enter_registered_address:'請輸入註冊地址',
  registered_address:'註冊地址：',
  enter_tax_number:'請輸入公司稅號',
  tax_number:'公司稅號：',
  enter_company_title:'請輸入公司名稱',
  company_title:'公司名稱：',
  mpre_content:'更多內容：',
  business_unit:'企業單位',
  individuals_corporate_units:'個人/非企業單位',
  header_type:'擡頭類型：',
  ordinary_invoice:'普通發票',
  value_added_tax:'增值稅專用發票',
  invoice_type:'發票類型：',
  Invoice_Information:'發票信息',
  Apply_invoice:'申請開票',
  Apply_time:'申請時間：',
  company_title_empty:'公司名稱不能為空',
  company_tax_num_empty:'公司稅號不能為空',
  company_tax_limit:'公司稅號僅限輸入英文或者數字',
  registered_address_empty:'註冊地址不能為空',
  registered_number_empty:'註冊電話不能為空',
  opening_bank_empty:'開戶銀行不能為空',
  bank_account_empty:'銀行賬號不能為空',
  connect_num_empty:'聯系電話不能為空',
  mailing_address_empty:'郵寄地址不能為空',
  amail_address_empty:'郵箱地址不能為空',
  enter_true_email:'請填寫正確的郵箱地址',
  rate_speed:'倍速',
  unLockTime:'{unLockTime} 會解鎖哦～',
  open_zhiniao:'請打開知鳥app完成作業',
  correct_answer:'正確答案',
  my_answers:'我的答案',
  after_start_exam:'開始考試後，{text}，否則系統將判定考試結束。',
  not_close_brower:'請勿關閉瀏覽器或離開考試界面',
  administrator_to_unblock:'已達到切屏最大次數，禁止再次進入考試，請聯系管理員解封',
  keep_screen_max:'請始終保持考試窗口最大化，否則無法開始考試',
  warning:'警告',
  cut_screen_times:'本次考試過程中禁止切屏，達到{maxTimes}次後，將視為作弊，自動交卷',
  cut_screen_maxTimes:'您已離開界面{maxTimes}次！已自動交卷',
  cheating_times:'您已離開界面{maxTimes}次！再離開考試{remainderTimes}次，將被視為作弊，自動交卷',
  examing_limit_tips:'考試中，請勿關閉瀏覽器或離開考試界面！',
  purchased_course:'已購課程',
  study_card:'學習卡課程',
  my_training_project:'我的培訓項目',
  resource_duration:'{resourceDuration}學時',
  regular:'正常',
  end_data:'到期日：{expireDate}',
  study_card_cover:'學習卡封面',
  terminated:'已停用',
  expired:'已過期',
  studyCard:'學習卡',
  zhiniao_cloud:'知鳥知識雲',
  go_cloud_home:'登錄企業無權限查看該知識空間，即將跳轉知識雲首頁',
  refund_amount:'退款金額(元):',
  detail_useNum:'已使用{useNum}人',
  refund_num:'退款數量(人):',
  apply_refund:'申請退款',
  check_refund_detail:'已退款，查看退款詳情',
  check_refund_record:'查看退款記錄',
  apay_time_colon:'支付時間:',
  order_time:'下單時間:',
  order_num:'訂單編號:',
  real_payment:'實付款：',
  no_coupons_available:'暫無優惠劵可用',
  pay_format:'付款方式:',
  coupons_colon:'優惠券:',
  student_colon:'學員：',
  student_info:'學員信息：',
  total_price:'總價：',
  transaction_complete:'交易完成',
  order_details:'訂單詳情',
  apply_refund_success:'退款申請成功',
  refund_price_zero:'退款金額不能為0',
  refund_num_zero:'退款數量不能為0',
  max_refund_num:'退款數量不能大於未使用數量',
  max_refund_price:'退款金額不能大於訂單金額',
  all_refund:'全部退費',
  part_refund:'部分退費',
  refund_failed:'退費失敗',
  apply_refund_fee:'申請退費',
  business_business_transfer:'公對公轉賬',
  WeChat_Pay:'微信支付',
  pay_by_AliPay:'支付寶支付',
  Cancelled:'已取消',
  Paid:'已支付',
  to_be_confirmed:'待確認',
  to_be_paid:'待支付',
  check_item:'查看項目',
  invoice_record:'開票記錄',
  no_my_order:'還沒有我的訂單',
  Refund_after_sale:'退款售後',
  price_from_text:"{text}起",
  price_from:"起",
  period_Total:'{periodTotal}個學時',
  training_duration_colon:'培訓學時:',
  no_my_training_item:'還沒有我的培訓項目',
  leran_precess:'學習進度',
  complete_duration_count:'完成{completedHours}/{requiredHours}學時',
  remainHours_duration_count:'剩余{remainHours}學時',
  buy_duration_count:'已購{remainHours}學時',
  register_now:'立即報名',
  Register_start_learning:'報名當前培訓項目即可開始學習',
  training_project_no_start:'培訓項目未開始!',
  export_learn_report:'導出學習報告',
  export_data_empty:'導出數據不能為空！',
  Check_is_blocked:'1.檢查是否被攔截：瀏覽器右上角出現如圖所示的提示',
  click_intercept_icon:'2.點擊攔截圖標，將選項修改為「允許顯示」',
  refresh_the_webpage:'3.刷新網頁，再次點擊「充值」',
  complete_fee_tips:'如果你已完成{feeWay1}，請點擊「已完成{feeWay2}」',
  sign_up:'報名',
  Recharge:'充值',
  opration_follow_steps:'如系統未打開系統充值頁面，請按照如下步驟操作',
  company_feeWay:'已完成{feeWay}',
  click_on:'點擊',
  cross_domain_image:'這是一張跨域圖片',
  cross_regional_picture:'來個跨區的圖片',
  Statistics_Time:'統計時間：',
  learned_availid_duration:'已完成有效學時：',
  Organization:'所屬組織：',
  Position_type_work:'崗位(工種)：',
  Credentials:'證件：',
  mobile_number_colon:'手機號：',
  staff_code:'員工編號：',
  gender:'性別：',
  name_colon:'姓名：',
  basic_information:'基礎信息',
  training_project_colon:'培訓項目：',
  personal_learning_report:'培訓項目個人學習報告',
  page_num:'頁碼: {index}/{arr}',
  data_from_colon:'數據出處：',
  catalog_list:'目錄({resourcesCount})',
  learned_no_refund:'在線課程學習後將不再退費',
  refrash_duration:'學時升級',
  i_go_sign_up:'我要報名',
  refunding_tips:'正在退款中, 不能{headDateil}',
  pageFrom_project:'{pageFrom}培訓項目',
  mine:'我的',
  project_study_report:'培訓項目個人學習報告',
  Pre_school_verification:'學前驗證實名認證',
  product_info:'商品信息',
  Specification:'規格',
  trading_status:'交易狀態',
  refund_details:'退款詳情',
  completed_time_colon:'完成時間：',
  sum_price:'總金額',
  payment_real:'實付款',
  RESOURCE_TYPE_team:'{RESOURCE_TYPE}(團體)',
  coursePeriod_duration:'{coursePeriod}學時',
  buyers_Num:'{buyersNum}人',
  study_information:'學員信息',
  order_information:'下單人信息',
  student_name_colon:'學員姓名:',
  phone_num_colon:'手機號碼:',
  order_info:'訂單信息',
  pay_time_colon:'付款時間:',
  no_available_coupons:'暫無可用優惠劵',
  refund_amount_colon:'退款金額:',
  refund_colon:'退款：',
  Public_public_payment:'公對公支付',
  Refund_under_review:'退款審核中',
  Payment_time_colon:'支付時間：',
  school_short_video:'學堂短視頻',
  school_live:'學堂直播',
  pay_success_confirm:'你已經成功付款',
  pay_failed:'支付失敗',
  WeChat_payment_limit:'請註意微信支付交易限額，若無法支付，可嘗試使用支付寶支付。',
  means_transaction:'交易方式',
  pay_money:'{payMoney}元',
  transaction_amount:'交易金額',
  use_WeChat_scan:'請使用微信掃碼支付',
  sevice_qus_connect:'如對知鳥購買服務存在疑問，請於法定工作日辦公時間（9:00-12:00，13:30-18:00）致電：400-603-8258與客服MM聯系',
  upgrade_immediately:'立即升級',
  Amounts_payable:'應付金額：',
  order_total_price:'訂單總價：{text}',
  Payment_Information:'支付信息：',
  payment_method:'支付方式：',
  After_upgrade:'升級後：',
  pre_upgrade:'升級前：',
  select_upgraded_specification:'請選擇升級的規格：',
  identity_number:'身份證號：',
  complete_student_information:'請完善學員信息',
  total_periodTotal:'共{periodTotal}個學時',
  enter_identity_numbe:'請輸入正確身份證號',
  enter_stu_name:'請輸入學生姓名',
  Certificate_being_generated:'證書生成中，請稍後查看',
  click_course_duration:'點擊課件成功播放消耗學時',
  buy_duration_learn:'請購買學時繼續學習',
  select_more_look:'集中觀看時，請選擇【多人觀看】，在場用戶便可計入學習數據，獲取學習激勵！',
  sign_QR_code:'簽到二維碼_{roomId}.png',
  QR_code_no_exist:'二維碼地址不存在！',
  use_app_login:'在場用戶登陸知鳥APP，掃碼簽到，簽到後不要離開哦，觀看結束時，還需繼續完成簽出！',
  scon_code_login:'掃碼簽到',
  after_sign_up:'簽到後，務必記得完成簽出！',
  scan_left_code:'知鳥APP - 左上角掃一掃',
  watching_intensively:'集中觀看時，掃碼簽到、簽出可獲得積分，抽取豪華大獎!',
  enter_live_sign:'進入直播間繼續簽到',
  scan_look:'掃碼觀看',
  sign_QR_code_room:'簽到二維碼_{roomId}',
  et_up_centralized:'首先，請先設置集中觀看的位置，在場用戶在該位置範圍內簽到和簽出',
  lower_meters:'米(≤1000米)',
  zhiniao_meeting:'知鳥會議',
  cloud_school_end:'當前雲教室已結束',
  hours_ago:'{h}小時',
  hours_min_detail:'{h}小時{m}分鐘',
  few_minutes:'{m}分鐘',
  use_other_browers:'請使用其他瀏覽器打開或復製鏈接到其他瀏覽器打開，謝謝',
  meeting_num:'會議號：',
  host_room_colon:'主持人：',
  phone_meeting:'手機參會',
  enter_meeting:'加入會議',
  scan_code_enter:'手機掃碼，加入雲教室',
  Arousing_client:'正在喚起客戶端…',
  Arousing_failed:'如未安裝或者喚起失敗，請點擊',
  download_client:'下載客戶端',
  admin_set_replay:'債權人會議已結束，如需觀看，請聯系管理人設置回放！',
  live_end_replay:'直播已結束，如需觀看，請聯系管理人設置回放！',
  check_in_ahead_time:'前, 請先提前完成簽到！',
  Remember_complete_checkout:'後, 務必記得完成簽出！',
  panelText_QR_code:'{panelText}二維碼_{roomId}',
  QR_code_loading:'二維碼加載中...',
  Draw_luxury_prizes:'集中觀看時，掃碼簽到、簽出可獲得積分，抽取豪華大獎!',
  scan_panelText:'掃碼{panelText}',
  currently_playing:'當前正在播放的就是當前視頻',
  next_video:'下一片段',
  add_look_data:'如部門集中觀看，可點擊右側開啟集中觀看二維碼計入部門觀看數據。',
  looking_sign_every_time:'觀看中，可隨時打開簽到碼讓未簽到人員補簽到',
  learnd_need_sign:'觀看結束後，需打開簽出二維碼，在場用戶完成簽出後方可計入學習數據',

  Password_live_room:"口令直播間",
  enter_live_room:"進入直播間",
  apply_live:"直播申請",
  enter_go_live:"點擊這裏可以申請直播哦～",
  enter_Password_live:"進入口令直播",
  people_num_icon:"人數icon",
  Service_Agreement:'服務協議' ,
  Zhiniao_Privacy_Polic: '知鳥隱私權政策',
  Ping_An_Software_Agreement:'平安知鳥軟件許可及服務協議',
  click_btn_verify:'點擊按鈕進行驗證',
  study_card_paid: '已購學習卡',
  knowledge_cloud: '知識雲',
  answer_questions: '請根據以上材料回答問題：',
  question_bank: '題庫',
  total_amount: '總價：￥{totalAmount}',
  job_develop_path: '岗位发展路径',
  to_start: '待開始',
  answer_questions: '請根據以上材料回答問題：',
  word: '口令',
}
